import { Component, Signal, computed, signal, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  // Get login error from auth service
  loginError: Signal<string | null>;

  // Session expired message
  sessionExpired = signal<boolean>(false);

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.loginError = computed(() => this.authService.loginError());
  }

  ngOnInit(): void {
    // Check if user was redirected due to session expiration
    this.route.queryParams.subscribe(params => {
      if (params['expired'] === 'true') {
        this.sessionExpired.set(true);
        // Clear the expired flag after showing the message
        setTimeout(() => this.sessionExpired.set(false), 10000); // Clear after 10 seconds
      }
    });
  }

  async loginWithGoogle() {
    // Clear session expired message when attempting new login
    this.sessionExpired.set(false);
    await this.authService.loginWithGoogle();
  }
}
